export default "__VITE_ASSET__D5gU5vP4__"